var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form_skeleton"},[_c('div',{staticClass:"form_skeleton_title"},[_c('span',{staticClass:"title_text"},[_vm._t("title")],2)]),_c('div',{staticClass:"form_skeleton_content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }